import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/healthcare/new/helathcareinsturments.jpg";
import Tab2Image from "../img/envision/healthcare/new/healthecaremangment.jpg";
import Tab3Image from "../img/envision/healthcare/new/healthcaresecurity.jpg";
import Tab4Image from "../img/envision/healthcare/new/pharmacetical.jpg";
import Tab5Image from "../img/envision/healthcare/cards/healthig5.jpg";
import Tab6Image from "../img/envision/healthcare/new/psistandards.jpg";
import Tab8Image from "../img/envision/healthcare/new/psistandards.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const HealthcareSecondVerticalTabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");
 const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    // const handleKnowMoreClick = () => {
    //     // Navigate to the documentaerospacepage with the specific hash
    //     navigate("/documentHealthcarePage#documentHealthcarePageSEeconddata");
    // };
    const handleKnowMoreClick = (tab) => {
        navigate(`/documentHealthcarePage?tab=${tab}#documentHealthcarePageSEeconddata`);
    };
    
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
      };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
       let tabInterval;
   
       if (!isHovered && isAutoPlayActive) {
         tabInterval = setInterval(() => {
           setActiveTab((prevTab) => {
             const nextTabNum = parseInt(prevTab.replace("tab", "")) % 5 + 1;
             return `tab${nextTabNum}`;
           });
         }, 3000);
       }
   
       return () => clearInterval(tabInterval);
     }, [activeTab, isHovered, isAutoPlayActive]);
   



    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {
            // display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            height: "425px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "15px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            // marginLeft: "10px",
            cursor:"pointer",
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            height:"360px"
        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
            
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
            <span style={{ color: "rgb(236 115 34)" }}> Integrated (ISO-PCI) </span>  Compliance services
            </h1>
            <div style={styles.container} className="tabclass-container-data">
                <div style={styles.tabNav} className="tabdata">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab1") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab1") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                        Medical Devices & Quality Management ISO standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab2") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab2") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                        Healthcare Management & Patient Safety standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab3") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab3") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                        Health Informatics & Data Security standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab4") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab4") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                        Pharmaceuticals & Biotech standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab5" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab5")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab5") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab5") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                        PCI standards
                    </button>
                    {/* <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab6" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab6")}
                        className="tab-button-width"
                    >
                        Information Security & Cybersecurity standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab7" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab7")}
                        className="tab-button-width"
                    >
                        Risk Management & Compliance 	standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab8" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab8")}
                        className="tab-button-width"
                    >
                        PCI standards
                    </button> */}

                </div>

                <div style={styles.card} className="card-data-vertica-tabs"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, }[activeTab]}
                        alt="Healthcare"
                        style={styles.image}
                        className="tab-image-data"
                    />
                    <div style={styles.textContent}>
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    [" ISO 13485 -Assessment of QMS for medical device manufacturers, Gap analysis and pre-certification audits + Vendor audits"],
                                    [" ISO 14971 - Risk Management audit for medical devices."],
                                    [" ISO 10993 and ISO 14155 - Biological safety evaluations and clinical trial process audits."],
                                ],
                                [
                                    [" ISO 9001 & ISO 45001 Audits:"],
                                    [" Evaluation of general and occupational quality and safety management systems in healthcare organizations. Focus on patient safety and staff well-being."],
                                    [" ISO 22870 (Point-of-Care Testing): Audit of POCT services and laboratory compliance."]

                                ],
                                [
                                    ["	ISO 27799 Information Security Audits:"],
                                    [" Assessment of IT infrastructure and processes for healthcare data protection. Cybersecurity audits for healthcare systems aligned with ISO/IEC 27001."],
                                    [" ISO 13606 EHR Compliance: Evaluation of electronic health records (EHR) communication systems."],
                                    [" Interoperability and data security audits."]

                                ],
                                [
                                    ["	ISO 15378 GMP Audits:"],
                                    [" Review of manufacturing processes for primary packaging materials. Supplier audits for GMP compliance."],
                                    [" ISO 16679 Tamper-Proof Packaging: Inspection and advisory for secure pharmaceutical packaging."],
                                    [" Interoperability and data security audits."]

                                ],
                                [
                                    ["	Audit on:"],
                                    ["	Secure Network & Systems."],
                                    [" Card holder data protection measures."],
                                    [" Vulnerability program."],
                                    ["  IS Policy"],
                                    [" Periodic Penetration testing & secure audits"]

                                ],
                                [
                                    [" ISO/IEC 27001 – Information Security Management System (ISMS) for BFSI data protection + Privacy Information Management System (extension of ISO 27001 for GDPR & data privacy)."],
                                    [" ISO/IEC 27017 – Security controls for cloud-based BFSI services."],
                                    [" ISO/IEC 27018 – Protection of personally identifiable information (PII) in cloud computing."],
                                    [" ISO/IEC 20000-1 – IT Service Management System (ITSM) for financial IT infrastructure."],
                                    [" ISO/IEC 22301 – Business Continuity Management System (BCMS) for financial institutions."]

                                ],
                                [
                                    ["	PCI DSS v4.0 – Ensuring secure card transactions for vehicle purchases, online bookings, and public transport payments."],
                                    [" PCI PTS – Secure PIN transaction systems for ticketing kiosks, vehicle dealerships, and retail points."],
                                    [" PCI PA-DSS – Secure software applications for payment processing in automotive dealerships and transport services."],
                                    [" PCI SSF (Software Security Framework) – Security standards for custom payment solutions integrated into mobility apps and platforms."]

                                ],
                                [
                                    ["	ISO 31000 – Risk management framework for BFSI."],
                                    ["  ISO 22316 – Organizational resilience standards for financial services."],
                                    [" ISO 19011 – Guidelines for internal auditing in banking and financial institutions."],
                                    [" ISO 37001 – Anti-bribery management system to prevent fraud in BFSI + Compliance management system for regulatory compliance in banking."]

                                ]
                            ];

                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((listItems, listIndex) => (
                                <ul key={listIndex}>
                                    {listItems.map((point, itemIndex) => (
                                        <li key={itemIndex}>{point}</li>
                                    ))}
                                </ul>
                            ));
                        })()}

                        {/* <button
                            style={styles.knowMoreButton}
                            onClick={handleKnowMoreClick}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
                        className="know-more-btn"
                        >
                            Know More
                        </button> */}
                           {["tab1", "tab2", "tab3","tab4","tab5"].includes(activeTab) && (
                            <button   style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                             onClick={() => handleKnowMoreClick(activeTab)} className="know-more-btn">
                                Know More
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Dot Navigation */}
            <div style={styles.dotNav}>
                {[...Array(5)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default HealthcareSecondVerticalTabs;
